<template>
  <div>
    <div v-if="loading" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
      加载中...
    </div>
  </div>
</template>

<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
      loading: true
    };
  },
  created() {
    this.getservicerurl();
  },
  methods: {
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        that.loading = false;
        if (res.code == 200 && res.data && res.data.url) {
          // 直接在新窗口打开客服链接
          window.open(res.data.url, '_blank');
          // 返回上一页
          that.$router.go(-1);
        } else {
          that.$parent.showTost(0, res.message || '客服链接获取失败');
          setTimeout(() => {
            that.$router.go(-1);
          }, 1500);
        }
      }).catch(err => {
        that.loading = false;
        that.$parent.showTost(0, '获取客服链接失败');
        setTimeout(() => {
          that.$router.go(-1);
        }, 1500);
      });
    },
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mode/kefu.vue